export enum DefaultColors {
  Red = '#ba1200',
  Green = '#618b4a',
  Blue = '#345995',
  Orange = '#ee6c4d',
}
